var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRightsIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1271_71156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4835 20.6346C12.1724 20.7546 11.8277 20.7546 11.5166 20.6346C9.08698 19.6819 7.00077 18.0192 5.53001 15.8634C4.05926 13.7076 3.2722 11.1586 3.27148 8.54885V4.61428C3.27148 4.25813 3.41296 3.91657 3.6648 3.66474C3.91663 3.4129 4.25819 3.27142 4.61434 3.27142H19.3858C19.7419 3.27142 20.0835 3.4129 20.3353 3.66474C20.5871 3.91657 20.7286 4.25813 20.7286 4.61428V8.53542C20.7306 11.1475 19.9448 13.6994 18.4738 15.8578C17.003 18.0164 14.9153 19.681 12.4835 20.6346Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40918 17.0094C7.61266 15.2038 9.66749 14.0143 12.0002 14.0143C14.3328 14.0143 16.3876 15.2038 17.5911 17.0094",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 12C13.6686 12 15.0214 10.6473 15.0214 8.97858C15.0214 7.30989 13.6686 5.95715 11.9999 5.95715C10.3313 5.95715 8.97852 7.30989 8.97852 8.97858C8.97852 10.6473 10.3313 12 11.9999 12Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_71156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRightsIconSelected);
export default __webpack_public_path__ + "static/media/UserRightsIconSelected.75a547eb851aa58a73ba3990e8ff1255.svg";
export { ForwardRef as ReactComponent };